import React from 'react';
import { Snackbar, Paper, Typography, IconButton, Box } from '@mui/material';

const customSuccessIconPath = process.env.PUBLIC_URL + '/icons/add_tenant_success_msg.svg';

interface LabelSuccessToastProps {
  open: boolean;
  message: string;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  onUndo: () => void;
}

const LabelSuccessToast: React.FC<LabelSuccessToastProps> = ({
  open,
  message,
  onClose,
  onUndo,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        zIndex: 1400,
        mt: 7.5,
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          alignItems: 'center',
          pl: 1.5,
          pr: 1,
          py: 1,
          borderRadius: '30px',
          backgroundColor: 'common.white',
          minWidth: '280px',
          maxWidth: '100%',
        }}
      >
        {/* Custom Icon Image */}
        <Box
          component="img"
          src={customSuccessIconPath}
          alt="Success"
          sx={{
            width: 33,
            height: 33,
            mr: 1,
          }}
        />

        {/* Message Text */}
        <Typography
          variant="body1"
          sx={{
            flexGrow: 1,
            color: 'text.primary',
            fontWeight: 500,
            fontSize: '14px',
          }}
        >
          {message}
        </Typography>

        {/* Undo Button with Custom SVG Icon */}
        <IconButton
          aria-label="undo"
          color="inherit"
          size="small"
          onClick={onUndo}
          sx={{
            color: 'text.secondary',
            ml: 1,
          }}
        >
          {/*
            ICON PLACEHOLDER:
            Replace "undo-icon.svg" with the name of your file from the public/icons folder.
          */}
          <Box
            component="img"
            src="/icons/undo-icon.svg" 
            alt="Undo"
            sx={{ width: 20, height: 20 }} // Adjust size as needed
          />
        </IconButton>
      </Paper>
    </Snackbar>
  );
};

export default LabelSuccessToast;